module.exports = __webpack_public_path__ + "static/media/ico-menu-01.fb52e037.svg";